export const shouldDisableField = (waitVariables, variableNames, camundaVariables) => {
    let disabled = waitVariables;

    if(waitVariables && variableNames && variableNames.length > 0 
            && camundaVariables && camundaVariables.camundaValues){

        const allRequiredFields = variableNames.filter(v => {
            
            return camundaVariables.camundaValues[v.key]?.value !== null 
                        && camundaVariables.camundaValues[v.key]?.value !== undefined
                        && camundaVariables.camundaValues[v.key]?.value !== ''
                        && camundaVariables.camundaValues[v.key]?.value !== false;
        });

        disabled = !(allRequiredFields.length === variableNames.length);
    } else{
        disabled = false;
    }

    return disabled;
}